import { SaveButton } from "components/Buttons"
import {
  TextField,
  SwitchInputField,
  CustomImageField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { CardImg, Col, Row } from "reactstrap"
import { change, Field, formValueSelector, reduxForm } from "redux-form"
import {
  hideChangePasswordModal,
  openChangePasswordModal,
  openPwdSecurityCheckModal,
} from "store/actions"
import validate from "./formValidation"

const ProfileForm = props => {
  const {
    handleSubmit,
    saveLoading,
    isOwnProfile,
    openChangePasswordModal,
    openPwdSecurityCheckModal,
    clientConfig,
    external_id,
  } = props
  const [axisCareEnabled, setAxisCareEnabled] = useState(false)

  useEffect(() => {
    if (clientConfig && clientConfig?.axis_care_integration_enabled) {
      setAxisCareEnabled(true)
    }
  }, [clientConfig])

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col lg={12}>
          <h5 className="font-size-14 mb-0">
            <i className="mdi mdi-arrow-right text-primary"></i>
            Profile Picture
          </h5>
          <Row className="my-3 px-3">
            <Col className="align-self-center" style={{ textAlign: "center" }}>
              <CardImg
                src={
                  props?.profile_pic?.editedImage
                    ? props?.profile_pic?.editedImage
                    : "https://admin.dev.markedprivate.com/app/images/profile_placeholder.jpg"
                }
                alt="image"
                className="rounded-circle avatar-xl"
              />
            </Col>
          </Row>
          <Row>
            <Col className="align-self-center" style={{ textAlign: "center" }}>
              <Field
                name="profile_pic"
                component={CustomImageField}
                onDelete={() => {
                  props.change("delete_file", 1)
                }}
                onChange={() => {
                  props.change("delete_file", 1)
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col lg={12}>
          <div className="mt-3 mb-3 pt-2">
            <h5 className="font-size-14 mb-0">
              <i className="mdi mdi-arrow-right text-primary"></i>
              Basic Information
            </h5>
          </div>

          <div className={"mb-1"}>
            <label>User Id:</label>&nbsp;
            <span>{props?.userId}</span>
          </div>

          <div className={"mb-3"}>
            <Field
              name={"first_name"}
              label={"First name*"}
              placeholder={"First name"}
              component={TextField}
            />
          </div>
          <div className={"mb-3"}>
            <Field
              name={"last_name"}
              label={"Last Name*"}
              placeholder={"Last Name"}
              component={TextField}
            />
          </div>

          <div className={"mb-3"}>
            <Field
              name={"email"}
              label={"Email*"}
              placeholder={"Email"}
              component={TextField}
            />
          </div>
          {!isOwnProfile && axisCareEnabled && (
            <div className={"mb-3"}>
              {<label>AxisCare ID</label>}

              <input
                placeholder={"AxisCare ID"}
                className={"form-control"}
                name={"axiscare_id"}
                id={"axiscare_id"}
                disabled={true}
                value={external_id}
                readOnly={true}
              />
            </div>
          )}
          <div className={"mb-3"}>
            <label>Password&nbsp;&nbsp;</label>
            <SaveButton
              type="button"
              content="Change Password"
              onClick={
                isOwnProfile
                  ? openChangePasswordModal
                  : openPwdSecurityCheckModal
              }
              size="sm"
            />
          </div>
        </Col>
        {!isOwnProfile && (
          <>
            <Col lg={12}>
              <div className="mt-3 mb-3 pt-2">
                <h5 className="font-size-14 mb-0">
                  <i className="mdi mdi-arrow-right text-primary"></i>
                  Social Profile
                </h5>
                <Row className="mt-1">
                  <Col>
                    <span>
                      (Below is how the user completed their social profile on
                      the app to be viewed by all)
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      name="public"
                      label="Public"
                      component={SwitchInputField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"display_name"}
                      label={"Display Name (how your name will appear to other users)"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"display_email"}
                      label={"Display Email (how your email will appear to other users)"}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"phone"}
                      label={"Phone #"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"gender"}
                      label={"Preferred Pronoun(s)"}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"birthday"}
                      label={"Birthday"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"birthdate"}
                      label={"Birth Date"}
                      component={TextField}
                      type="date"
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"title"}
                      label={"Title/Profession"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"company"}
                      label={"Company"}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"hire_date"}
                      label={"Hire or Start Date"}
                      component={TextField}
                      type="date"
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field name={"bio"} label={"Bio"} component={TextField} />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"interests"}
                      label={"Interests"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"country"}
                      label={"Country"}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field name={"city"} label={"City"} component={TextField} />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"state"}
                      label={"State"}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"zip_code"}
                      label={"Zip code"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"fb_link"}
                      label={"Facebook"}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"insta_link"}
                      label={"Instagram"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"tw_link"}
                      label={"X (Twitter)"}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"linkedin_link"}
                      label={"LinkedIn"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"pinterest_link"}
                      label={"Pinterest"}
                      component={TextField}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-3">
                  <Col xs={12} md={6}>
                    <Field
                      name={"yt_link"}
                      label={"Youtube"}
                      component={TextField}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Field
                      name={"tiktok_link"}
                      label={"TikTok"}
                      component={TextField}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </>
        )}
      </Row>

      <Row className="d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton content={"Save"} loading={saveLoading} />
        </Col>
      </Row>
    </form>
  )
}

const selector = formValueSelector(FORM_NAMES.PROFILE)

const mapStateToProps = state => ({
  changePasswordModalIsOpen: state.Profile.changePasswordModalIsOpen,
  profile_pic: selector(state, "profile_pic"),
  clientConfig: state.Login.clientConfig,
  external_id: selector(state, "external_id"),
})

const mapDispatchToProps = dispatch => ({
  openChangePasswordModal: () => dispatch(openChangePasswordModal()),
  hideChangePasswordModal: () => dispatch(hideChangePasswordModal()),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PROFILE, `${field}`, value)),
  openPwdSecurityCheckModal: () => dispatch(openPwdSecurityCheckModal()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAMES.PROFILE, // must be unique
    validate,
  })(ProfileForm)
)
